export default "__VITE_ASSET__DnUjiXrb__"